import React, { useEffect } from "react";
import Styled from "styled-components";
import Sapimg from "../Images/SAPImage.png";
import lie from "../Images/lie.jpg";
export default function Sap() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <DIV>
      <BOX>
        <h1>Erudite Lecture Series</h1>

        <COLOR>
          <TOP>
            <p className="above">
              The Erudite Scholar in Residence Program is a flagship program of
              the Kerala State Higher Education Council (KSHEC) which enables
              Indian Universities to invite Nobel Laureates and other eminent
              scholars for interaction with their talented young students,
              faculties and researchers.
            </p>
            <p className="below">
              Prof. N. R. Madhava Menon Centre hosted an Erudite Lecture series
              in 2021 with Prof. (Dr) Reidar Krummradt Lie as the Erudite
              Scholar. The program was virtually inaugurated on 1st of October,
              2021 by the Hon’ble Vice Chancellor of CUSAT Prof. (Dr) K. N.
              Madhusoodanan. The online lecture series which followed was
              extended over ten days. Over 1600 eminent scholars, researchers,
              faculties, renowned academicians, health care professionals,
              lawyers and students from the various disciplines of science and
              law participated in the program, virtually. Webinars and panel
              discussions were conducted as a part of the program in
              collaboration with various institutions like the Cochin Cancer
              Research Centre, Regional Cancer Care Trivandrum, Government
              Medical College Ernakulam, Kerala University of Health Sciences,
              Department of Biotechnology of CUSAT, National University of
              Advanced Legal Studies Kochi, Kannur University Kerala, School of
              Legal Studies of CUSAT, etc.
            </p>
          </TOP>
          <H4>Prof. (Dr) Reidar Krummradt Lie</H4>
          <img
            src={lie}
            alt="image"
            style={{ height: "149px", width: "164px" }}
          ></img>
          <p>
            {" "}
            Prof. Lie is a Professor of Philosophy and the Head of the
            Department of Philosophy of the University of Bergen, Norway. He is
            also an Adjunct Professor at the Institute of Basic Medical Sciences
            at the Chinese Academy of Medical Sciences, Perking Union Medical
            College, Beijing. Prof Lie is the Adjunct Senior Research Fellow at
            the Department of Bioethics of the National Institutes of Health
            (NIH), USA.{" "}
          </p>
        </COLOR>
      </BOX>
    </DIV>
  );
}
const H3 = Styled.h3`
    font-family: PT Serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
    @media (max-width:395px){
      font-size: 14px;
    }
   `;
const H4 = Styled.h4`
   font-family: PT Serif;
   font-style: normal;
   font-weight: normal;
   font-size: 20px;
   line-height: 16px;
   color: #000000;
   @media (max-width:640px){
    font-size: 18px;
  }
  @media (max-width:540px){
    font-size: 16px;
  }
  @media (max-width:395px){
    font-size: 14px;
  }`;
const DIV = Styled.div`

background: #FAFAFA;
display:flex ;
justify-content:center;
align-items: center;
width:100%;
`;

const BOX = Styled.div`

width:85%;
margin:50px auto;
h1{
  font-family: Oswald;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 36px;
  font-weight:500;
  color: #E01E38;
  display:flex;
 }
 @media (max-width:1132px){
 h1{
  font-size: 32px;
  }
}
@media (max-width:1065px){
  h1{
   font-size: 31px;
   }
 }
 @media (max-width:534px){
  h1{
   font-size: 28px;
   }
 }
 @media (max-width:395px){
  padding: 16px;
  h1{
   font-size: 26px;
   }
 }
li{
    margin-left:50px;
    text-align:justify;
    font-size:20px;
    line-height:24px;
    font-family: PT Serif;
   
}
@media (max-width:640px){
   li{
    font-size:18px;
   }
}
@media (max-width:534px){
  li{
    font-size:16px;
  }
 }
 @media (max-width:395px){
  li{
    font-size:14px;
  }
 }
`;
const COLOR = Styled.div`
background:white;
padding:20px 40px;
box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
`;

const TOP = Styled.div`
@media (max-width:530px){
  display:flex;
  flex-direction:column;
  align-items:center;
}
 p.above{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
  }
 p.below{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
 }


`;
